// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationAddressModel {
    static getAttributeTypeMap() {
        return LocationAddressModel.attributeTypeMap;
    }
}
LocationAddressModel.discriminator = undefined;
LocationAddressModel.additionalProperties = false;
LocationAddressModel.attributeTypeMap = [
    {
        "name": "businessName",
        "baseName": "businessName",
        "type": "string"
    },
    {
        "name": "line1",
        "baseName": "line1",
        "type": "string"
    },
    {
        "name": "line2",
        "baseName": "line2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
];
//# sourceMappingURL=locationAddressModel.js.map